import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultMemberMembershipStartDateDisplayText = {
    label: 'Member since',
    format: '${membershipStartDate|d|DD/MM/YYYY}'
};
export const memberMembershipStartDateDisplayTextValidatorSchema = {
    label: nonEmptyStringValidator,
    format: nonEmptyStringValidator
};
export const memberMembershipStartDateDisplayTextValidator = Validator.object(memberMembershipStartDateDisplayTextValidatorSchema);
